import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils.js";

const baseUrl = "/api/sif/pripustKondicijaSamice";

export const fetchMatingFitnessFemale = createAsyncThunk(
  "matingFitnessFemale/list",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(baseUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchMatingFitnessFemalePage = createAsyncThunk(
  "matingFitnessFemale/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchMatingFitnessFemaleBySifra = createAsyncThunk(
  "matingFitnessFemale/byCode",
  async (sifra, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(`${baseUrl}/${sifra}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const matingFitnessFemaleSlice = createSlice({
  name: "matingFitnessFemale",
  initialState: {
    page: null,
    list: [],
    byId: {},
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMatingFitnessFemale.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(fetchMatingFitnessFemale.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchMatingFitnessFemale.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMatingFitnessFemalePage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchMatingFitnessFemalePage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchMatingFitnessFemalePage.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMatingFitnessFemaleBySifra.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMatingFitnessFemaleBySifra.fulfilled, (state, action) => {
        state.isLoading = false;
        const item = action.payload;
        if (item?.sifra) {
          state.byId[item.sifra] = item;
          state.details = item.sifra;
        }
      })
      .addCase(fetchMatingFitnessFemaleBySifra.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default matingFitnessFemaleSlice.reducer;
